import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../utils/api'

/**
 * Hook para obtener los elementos, filtrados opcionalmente por deviceIds
 * y por unidad (ppb/ppm), cacheados con React-Query.
 */
function useElements(deviceIds = [], filterByUnit = false) {
  const {
    data: elements = [],
    isLoading,
    error
  } = useQuery(
    ['elements', deviceIds],
    async () => {
      const url = deviceIds.length === 0
        ? '/api/elements'
        : '/api/elements/by-devices'
      const opts = deviceIds.length === 0
        ? { credentials: 'include' }
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ids: deviceIds })
          }

      const res = await apiFetch(url, opts);
      if (!res) {
        return;
      }
      if (!res.ok) {
        throw new Error('Error loading elements')
      }
      return res.json()
    },
    {
      staleTime: 1000 * 60,
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false
    }
  )

  const elemsMemo = useMemo(() => {
    if (!filterByUnit) return elements
    return elements.filter(el => el.unit === 'ppb' || el.unit === 'ppm')
  }, [elements, filterByUnit])

  return {
    elements: elemsMemo,
    loading: isLoading,
    error
  }
}

export default useElements
